import { render, staticRenderFns } from "./managerank.vue?vue&type=template&id=71f7796f&scoped=true&"
import script from "./managerank.vue?vue&type=script&lang=js&"
export * from "./managerank.vue?vue&type=script&lang=js&"
import style0 from "./managerank.vue?vue&type=style&index=0&id=71f7796f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f7796f",
  null
  
)

export default component.exports